import { Component } from '@angular/core';


@Component({
  selector: 'xform-404',
  templateUrl: './page-not-found.component.html'
})
export class PageNotFoundComponent {}
